import { EntTerritorialsUnits } from "../handBooks/territorialsUnits";
import { EntDirectoryInfoName } from "../directoryInfoName";
import { EntBasicHB } from "../handBooks/basicHB";
import { EntTypeProduct } from "../handBooks/typeProduct";

export class EntTheNeedsOfThePopulation {
  id: number|null = null;
  year: number|null = null;
  region: EntTerritorialsUnits|null = null;
  area: EntTerritorialsUnits|null = null;
  territorialUnit: EntTerritorialsUnits|null = null;
  productType: EntTypeProduct|null = null;
  latitude: number|undefined = undefined;
  longitude: number|undefined = undefined;
  averageConsumption: number|null = null;
  population: number|null = null;
  totalConsumptionTonnes: number|null = null;
  deleted: boolean|null = null;
  editedTime: string|null = null;
  createdTime: string|null = null;
  
  // ID fields for API requests
  regionId: number|null = null;
  areaId: number|null = null;
  territorialUnitId: number|null = null;
  productTypeId: number|null = null;
}

export class TheNeedsOfThePopulation {
  id: number|null = null;
  processingCapacityRegisterId: number|null = null;
  industryType: EntBasicHB|null = null;
  rawMaterial: EntBasicHB|null = null;  
  productType: EntTypeProduct|null = null;
  tonnesPerDay: number|null = null;
  storageCapacityTonnes: number|null = null;
  seasonality: EntBasicHB|null = null;
  equipmentDescription: string|null = null;
  isItExported: boolean|null = null;
  certificate: EntBasicHB|null = null;
  destinationCitizenship: EntBasicHB|null = null;
}
